import { render, staticRenderFns } from "./removeBuddy.vue?vue&type=template&id=171930ef&"
import script from "./removeBuddy.vue?vue&type=script&lang=js&"
export * from "./removeBuddy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports